export default {
  apartment: {
    apartment: "Apartment",
    apartments: "Apartments",
  },
  holding: {
    holding: "Holding",
    holdings: "Holdings",
  },
  lease: {
    lease: "Lease",
    leases: "Leases",
  },
  sublet: {
    sublet: "Sublet",
    sublets: "Sublets",
  },
  person: {
    person: "Person",
    persons: "Persons",
  },
  organization: {
    organization: "Organization",
    organizations: "Organizations",
  },
  role: {
    role: "Role",
    roles: "Roles",
  },
};
